import { Injectable } from '@angular/core';
import { ConfigService } from '../utils/config-service';
import { HttpClient } from '@angular/common/http';
import { GlobalName } from '../utils/global-name';

@Injectable({
  providedIn: 'root'
})
export class CommentService {

  url=ConfigService.toApiUrl("v1/comments/");

  constructor(private http:HttpClient) { }

    getAll(){
    return this.http.get<any[]>(`${this.url}`);
  }
 
  getByState(state:any){
    return this.http.get<any[]>(`${ConfigService.toApiUrl("comments-by-state")}/${state}`);
  }

  store(ressource:any){
    return this.http.post<any>(`${this.url}`, ressource,
     ConfigService.httpHeader(localStorage.getItem(GlobalName.tokenName),true));
  }

  update(id:any,ressource:any){
    //ressource['_method']='patch';
    ressource.append('_method','patch');

    return this.http.post<any>(`${this.url}${id}`, ressource,  ConfigService.httpHeader(localStorage.getItem(GlobalName.tokenName),true));
  }
  delete(id:any){
    return this.http.delete<any>(`${this.url}${id}`,
     ConfigService.httpHeader(localStorage.getItem(GlobalName.tokenName),true));
  }

  get(id:any){
    return this.http.get<any>(`${this.url}${id}`,
     ConfigService.httpHeader(localStorage.getItem(GlobalName.tokenName),true));
  }

  setState(id:any,state:any){
    return this.http.get<any[]>(`${ConfigService.toApiUrl("comments-set-state")}/${id}/state/${state}`);
  }
}
